// all pages inser here

import { Login , Forget, Register } from "./auth";
import { Dashboard } from "./dashboard";
import { Rollcall, RollcallAdd, RollcallEdit, Delay, OverTime, Absence, Vacation, VacationEdit, VacationAdd } from "./reports";
import { Users, UsersAdd , UsersEdit } from "./users";
import { HolidaysAdd, HolidaysEdit, Holidays, DelayReasons, DelayReasonsAdd, DelayReasonsEdit, JobGroups, JobGroupsAdd, JobGroupsEdit, Job, JobAdd, JobEdit, Operations, OperationsAdd, OperationsEdit, VcationReasons, VcationReasonsEdit, VcationReasonsAdd , Schedules , SchedulesAdd , SchedulesEdit , AccessLevel , AccessLevelAdd , AccessLevelEdit , Admin , AdminAdd , AdminEdit } from "./settings";
import { Company } from "./company";
import { Location ,LocationAdd , LocationEdit} from "./location";
import { Ticket , TicketAdd } from "./tickets";
import { PurchaseHistory } from "./purchase-history";
import { Plan , PlanResult } from "./plan";
export * from './module'

export {
    Login,
    Forget ,
    Register,
    Dashboard,
    Rollcall,
    RollcallAdd,
    RollcallEdit,
    Delay,
    Absence,
    Vacation,
    VacationAdd,
    VacationEdit,
    Users,
    UsersAdd ,
    UsersEdit ,
    OverTime,
    JobGroups,
    JobGroupsAdd,
    JobGroupsEdit,
    Job,
    JobAdd,
    JobEdit,
    Admin ,
    AdminAdd ,
    AdminEdit ,
    AccessLevel , 
    AccessLevelAdd , 
    AccessLevelEdit ,
    Operations,
    OperationsAdd,
    OperationsEdit,
    VcationReasons,
    VcationReasonsEdit,
    VcationReasonsAdd,
    DelayReasons,
    DelayReasonsAdd,
    DelayReasonsEdit,
    HolidaysAdd,
    HolidaysEdit,
    Holidays,
    Schedules , 
    SchedulesAdd,
    SchedulesEdit ,
    Location ,
    LocationAdd ,
    LocationEdit ,
    Ticket ,
    TicketAdd ,
    PurchaseHistory,
    Plan,
    PlanResult ,
    Company
}